import { Dispatch, SetStateAction, useState } from "react";
import { Box, Typography, Chip, TextField, Button } from "@mui/material";

type InvitationEmailsProps = {
    clientEmail: string | null;
    additionalEmails: Array<string>;
    setAdditionalEmails: Dispatch<SetStateAction<Array<string>>>;
    meetingName: string
};

export const InvitationEmails = ({
    clientEmail,
    additionalEmails,
    setAdditionalEmails,
    meetingName
}: InvitationEmailsProps) => {
    const [emailInput, setEmailInput] = useState("");
    const [errorEmail, setErrorEmail] = useState(false);

    const handleRemoveEmail = (email: string) => {
        setAdditionalEmails((prev) => prev.filter((e) => e !== email));
    };

    const handleAddEmail = (newEmail: string) => {
        const trimmedEmail = newEmail.trim();
        const isValidEmail = /\S+@\S+\.\S+/.test(trimmedEmail);

        if (!isValidEmail) {
            setErrorEmail(true);
            return;
        }

        setErrorEmail(false);

        if (trimmedEmail && trimmedEmail !== clientEmail && !additionalEmails.includes(trimmedEmail)) {
            setAdditionalEmails((prev) => [...prev, trimmedEmail]);
            setEmailInput("");
        }
    };

    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Typography sx={{ fontWeight: "bold", color: "primary.dark" }} variant="subtitle2">
                    A convidar para a {meetingName}
                </Typography>
                {clientEmail && <Typography sx={{ margin: "6px" }}>{clientEmail}</Typography>}
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: 2,
                    }}
                >
                    {additionalEmails.map((email) => (
                        <Chip
                            key={email}
                            label={<span style={{ userSelect: "text" }}>{email}</span>}
                            onDelete={() => handleRemoveEmail(email)}
                        />
                    ))}
                </Box>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", mt: 2 }}>
                <TextField
                    size="small"
                    margin="dense"
                    label="Se necessário acrescente emails"
                    InputLabelProps={{ sx: { fontSize: "0.9rem" } }}
                    variant="outlined"
                    value={emailInput}
                    onChange={(e) => setEmailInput(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleAddEmail(emailInput)}
                    fullWidth
                />
                <Button
                    size="small"
                    onClick={() => handleAddEmail(emailInput)}
                    sx={{ mt: 1, mb: 1, width: "fit-content" }}
                >
                    Adicionar
                </Button>
            </Box>
            <Typography sx={{ opacity: errorEmail ? 1 : 0 }} variant="body2" color="error">
                Email não é válido
            </Typography>
        </>
    );
};
